// extracted by mini-css-extract-plugin
export var compactFilters = "_fu-4";
export var detailImage = "_fu-1";
export var dropdownContainer = "_fu-2";
export var imageContainer = "_fu-0";
export var selectedCard = "_fu-3";